export const policy = `<div class="page">
  <h1 class="title" data-reader-unique-id="titleElement">
    Politique de confidentialité
  </h1>
  <h2 data-reader-unique-id="1">
    <strong data-reader-unique-id="2">PREAMBULE</strong>
  </h2>
  <p data-reader-unique-id="3">
    Cette Politique de confidentialité s’adresse à vous, (ci-après « vous » ou «
    Utilisateurs »), Lorsque vous naviguez sur le site internet
    <a
      href="${location.origin}"
      data-reader-unique-id="4"
      ><strong data-reader-unique-id="5">${location.origin}</strong></a
    > (ci-après « le Site »), et/ou utilisent les
    services proposés par WEEDEV depuis les pages d’interfaces de mise en
    contact (ci-après la ou les « Interface(s) », en fonction).
  </p>
  <p data-reader-unique-id="4">
    Elle a pour objectif de vous informer sur la manière dont vos informations
    personnelles peuvent être collectées et traitées par la société WEEDEV
    (ci-après dénommée « WEEDEV »).
  </p>
  <p data-reader-unique-id="5">
    Le respect de votre vie privée et de vos données à caractère personnel est
    l’une de nos priorité, raison pour laquelle nous nous engageons à traiter
    vos données dans le plus strict respect de la Loi Informatique et Libertés
    du 6 janvier 1978 modifiée par la loi n° 2018-493 du 20 juin 2018 (ci-après
    la « Loi Informatique et Libertés ») et du Règlement général sur la
    protection des données du Conseil de l’Europe du 27 avril 2016 (ci-après le
    « RGPD »).
  </p>
  <h2 data-reader-unique-id="6">
    <strong data-reader-unique-id="7">INFORMATIONS COMPLÉMENTAIRES </strong>
  </h2>
  <p data-reader-unique-id="8">
    WEEDEV est susceptible de modifier la présente Politique à tout moment
    pour l’adapter aux évolutions législatives et à celles de ses activités. Ces
    modifications prendront effet dès leur publication sur le Site. Nous vous
    invitons, par conséquent, à consulter la présente Politique fréquemment.
  </p>
  <p data-reader-unique-id="9">
    WEEDEV s’efforce d’assurer un niveau de protection élevé des données
    personnelles des Utilisateurs, en conformité avec le Règlement n° 2016/679
    du 27 avril 2016 relatif à la protection des personnes physiques à l’égard
    du traitement des données à caractère personnel et à la libre circulation de
    ces données (ci-après « RGPD ») et de la loi n° 78-17 du 6 janvier 1978
    relative à l’informatique, aux fichiers et aux libertés « ci-après « CNIL
    »).
  </p>
  <h2 data-reader-unique-id="10">
    <strong data-reader-unique-id="11"
      >2. DONNÉES PERSONNELLES, TRAITEMENTS : DE QUOI PARLE-T-ON ?
    </strong>
  </h2>
  <p data-reader-unique-id="12">
    Qu’est-ce qu’une donnée personnelle ? Ce sont toutes informations relatives
    à une personne physique, permettant directement ou indirectement de
    l’identifier, soit par référence à un élément qui lui est propre (ex. : nom,
    prénom, etc.), soit à l’aide du croisement d’un ensemble de données (ex. :
    coordonnées, numéro de carte de fidélité, adresse IP, etc.).
  </p>
  <p data-reader-unique-id="13">
    Qu’est-ce qu’un traitement de données personnelles ? Cela désigne toutes les
    opérations, automatisées ou non, portant sur des données personnelles (ex. :
    la collecte, l’enregistrement, l’organisation, la conservation, la
    modification, l’utilisation, la diffusion, l’effacement, etc.).
  </p>
  <p data-reader-unique-id="14">
    Pour en savoir davantage sur la protection des données personnelles et vos
    droits, vous pouvez consulter le site internet de la Commission Nationale de
    l’Informatique et des Libertés (<a
      href="https://www.cnil.fr"
      target="_blank"
      data-reader-unique-id="15"
      >www.cnil.fr</a
    >). <strong data-reader-unique-id="16">‍</strong>
  </p>
  <h2 data-reader-unique-id="17">
    <strong data-reader-unique-id="18"
      >3. IDENTITE &amp; COORDONNEES DES RESPONSABLES CONJOINTS DE TRAITEMENT
    </strong>
  </h2>
  <p data-reader-unique-id="19">
    Le responsable du traitement de données effectué via le site internet est la
    société WEEDEV
  </p>
  <h3 data-reader-unique-id="20">
    <strong data-reader-unique-id="21"
      >3.1 COORDONNEES DU DELEGUE A LA PROTECTION DES DONNEES
    </strong>
  </h3>
  <p data-reader-unique-id="22">
    WEEDEV a nommé un Délégué à la Protection des Données (ci-après « DPO
    ») chargé de répondre à toutes vos demandes, y compris d’exercice de droits,
    relatives à vos données à caractère personnel. Vous pouvez le joindre :
  </p>
  <ul role="list" data-reader-unique-id="23">
    <li data-reader-unique-id="24">
      Soit par mail à l’adresse suivante : dpo@hipto.com
    </li>
    <li data-reader-unique-id="25">
      Soit par courrier : DPO WEEDEV,  114, rue Gallieni 92100 Boulogne-Billancourt.
    </li>
  </ul>
  <p data-reader-unique-id="26">
    ‍<strong data-reader-unique-id="27">‍</strong>
  </p>
  <h2 data-reader-unique-id="28">
    <strong data-reader-unique-id="29"
      >4. COLLECTE &amp; ORIGINE DES DONNEES
    </strong>
  </h2>
  <p data-reader-unique-id="30">
    Dans le cadre de l’exploitation de son Site, WEEDEV collecte et traite
    des données à caractère personnel relatives à ses Utilisateurs. En utilisant
    notre site internet et/ou en souscrivant à nos services et/ou en acceptant
    le traitement de vos données, vous nous transmettez un certain nombre
    d’informations à votre sujet dont certaines sont de nature à vous identifier
    (« Données à caractère personnel »).
  </p>
  <ol start="1" role="list" data-reader-unique-id="31">
    <li data-reader-unique-id="32">
      <strong data-reader-unique-id="33"
        >Lors de la demande de mise en contact
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="34">
    À cette occasion, WEEDEV collecte les Données à caractère personnel que
    Vous renseignez en complétant les champs du questionnaire. Les données
    personnelles devant être obligatoirement renseignées pour être mis en
    relation avec l’un de nos Partenaires sont systématiquement indiquées par un
    astérisque (*). WEEDEV est également susceptible de collecter des
    données personnelles complémentaires à votre sujet. Vous êtes libres de
    renseigner ou non les champs des Interfaces qui ne sont pas requis. La
    nature et l’étendue des données personnelles collectées dépendent ainsi :
  </p>
  <ul role="list" data-reader-unique-id="35">
    <li data-reader-unique-id="36">
      d’une part, de l’objet de votre demande de mise en contact ;
    </li>
    <li data-reader-unique-id="37">
      d’autre part, des produits et/ou services que vous recherchez.
    </li>
  </ul>

  <p data-reader-unique-id="39">
    Toutes ces données personnelles sont collectées lorsque vous confirmez votre
    demande. Sachez que lorsque vous confirmez votre demande de mise en contact,
    WEEDEV est susceptible de vous adresser un SMS au numéro de téléphone
    mobile que vous avez renseigné afin de confirmer les coordonnées de contact
    indiquées ou de vous proposer une prise de rendez-vous à votre convenance.
  </p>

  <p data-reader-unique-id="41">
    WEEDEV est susceptible de collecter, en fonction des situations, les
    données personnelles suivantes :
  </p>

  <p data-reader-unique-id="43">
    <strong data-reader-unique-id="44">TYPES</strong>
  </p>
  <p data-reader-unique-id="45">
    <strong data-reader-unique-id="46">DONNÉES PERSONNELLES COLLECTÉES</strong>
  </p>
  <p data-reader-unique-id="47">Données d'identification</p>
  <p data-reader-unique-id="48">
    Cela comprend toutes les informations qui nous permettraient de vous
    identifier, telles que votre nom, prénom, numéro de téléphone, votre adresse
    mail, votre adresse postale.
  </p>
  <p data-reader-unique-id="49">Vie privée</p>
  <p data-reader-unique-id="50">
    Cela comprend des informations relatives à vos habitudes de vie, à votre
    situation familiale, l’existence d’animaux domestiques ou à vos habitudes de
    consommation, la survenance ou l’absence d’un sinistre, etc.
  </p>
  <p data-reader-unique-id="51">Vie professionnelle</p>
  <p data-reader-unique-id="52">
    Cela comprend des informations sur vos fonctions, sur votre métier, votre
    adresse professionnelle, votre numéro de téléphone professionnel, votre
    adresse mail professionnelle etc.
  </p>
  <p data-reader-unique-id="53">Données économiques et financières</p>
  <p data-reader-unique-id="54">
    Cela comprend votre niveau de revenu par fourchette, une estimation de votre
    patrimoine par fourchette, si vous êtes propriétaire ou locataire de votre
    logement etc.
  </p>
  <p data-reader-unique-id="55">
    Données concernant les habitudes de consommation
  </p>
  <p data-reader-unique-id="56">
    Cela comprend le nom du fournisseur, les forfaits qui ont été souscrits, les
    besoins de consommation, la qualité de la satisfaction du client et toutes
    autres informations liées à ces habitudes de consommation.
  </p>
  <p data-reader-unique-id="57">Données recueillies auprès des Tiers</p>
  <p data-reader-unique-id="58">
    Les Données à caractère personnel que vous avez accepté de partager avec
    nous ou sur les réseaux sociaux accessibles au public et/ou que nous
    pourrions collecter à partir d’autres bases des Données accessibles au
    public.
  </p>

  <p data-reader-unique-id="60">
    A la suite de votre demande, WEEDEV obtient des informations de ses
    Partenaires sur la ou les suite(s) données par les Utilisateurs aux offres
    qui leur ont été proposées à l’issue de la mise en contact avec ces
    derniers.
  </p>

  <p data-reader-unique-id="62">
    Les informations obtenues se limitent à ce qui est strictement nécessaire
    pour permettre l’exécution du contrat qui lie WEEDEV, en tant
    qu’intermédiaire, aux Partenaires.
  </p>

  <ol start="2" role="list" data-reader-unique-id="64">
    <li data-reader-unique-id="65">
      <strong data-reader-unique-id="66"
        >Lors de la consultation du site
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="67">
    À cette occasion, WEEDEV collecte les Données à caractère personnel ces
    données ne sont pas transférées à nos Partenaires, sous réserve des
    informations de l’article 5.1 « Le transfert des données personnelles aux
    Partenaires ».
  </p>

  <p data-reader-unique-id="69">
    <strong data-reader-unique-id="70">TYPES</strong>
  </p>
  <p data-reader-unique-id="71">
    <strong data-reader-unique-id="72">DONNÉES PERSONNELLES COLLECTÉES</strong>
  </p>
  <p data-reader-unique-id="73">Données de connexion</p>
  <p data-reader-unique-id="74">Cela comprend votre adresse IP,</p>

  <h2 data-reader-unique-id="76">
    <strong data-reader-unique-id="77"
      >5. LES TRANSFERTS DES DONNÉES PERSONNELLES
    </strong>
  </h2>
  <ol start="1" role="list" data-reader-unique-id="78">
    <li data-reader-unique-id="79">
      <strong data-reader-unique-id="80"
        >Le transfert des données personnelles aux Partenaires
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="81">
    S’agissant d’un service de mise en contact initié par les Utilisateurs,
    leurs données personnelles sont collectées dans le but d’être transférées à
    un ou des Partenaires, en fonction de la recherche des Utilisateurs,
    susceptible(s) de répondre à leur(s) besoin(s).
  </p>
  <p data-reader-unique-id="82">
    Une fois obtenues, le ou les Partenaire(s) concerné(s) est/sont
    responsable(s) de traitement des données personnelles des Utilisateurs ainsi
    transférées, par exemple lorsqu’il(s) décide(nt) de vous contacter ou de
    prendre rendez-vous avec vous. Le ou les Partenaire(s) concerné(s) ne
    peuvent pas utiliser les données personnelles des Utilisateurs pour d’autres
    finalités qu’entrer en contact avec ces derniers en vue de répondre à
    leur(s) besoin(s) et, le cas échéant, donner suite aux offres pour
    lesquelles les Utilisateurs manifestent un intérêt. En conséquence, si le ou
    Partenaire(s) concerné(s) souhaite(nt), une fois vous avoir présenté leur(s)
    offre(s) correspondantes à vos besoins, vous adresser en complément des
    publicités, ils doivent recueillir votre consentement, à moins que celui-ci
    ne soit pas requis en application d’une disposition législative ou
    réglementaire.
  </p>
  <p data-reader-unique-id="83">
    Dans certains cas, lorsque votre demande de mise en contact est adressée à
    un seul Partenaire, WEEDEV peut vous proposer de consentir à recevoir
    des sollicitations publicitaires de ce Partenaire. Dans cette hypothèse,
    WEEDEV se contente de recueillir votre consentement et de transmettre
    la preuve de votre accord au Partenaire. Les usages ultérieurs de vos
    données personnelles à cette fin sont réalisés par le Partenaire seul, sous
    sa seule responsabilité. En aucun cas WEEDEV ne vous adresse des
    sollicitations publicitaires.
  </p>
  <p data-reader-unique-id="84">
    WEEDEV peut également être amené à transférer votre adresse IP à des
    Partenaires lorsque ces derniers l’utilisent pour s’assurer de la bonne
    exécution par WEEDEV de la demande de mise en contact. Dans ce cas, les
    Partenaires ne peuvent pas utiliser votre adresse IP à d’autres fins.
  </p>
  <p data-reader-unique-id="85">
    Sachez qu’WEEDEV ne transfère pas vos données personnelles à des
    Partenaires qui ne sont pas susceptibles de répondre aux besoins exprimés au
    regard de votre recherche initiale.
  </p>
  <ol start="2" role="list" data-reader-unique-id="86">
    <li data-reader-unique-id="87">
      <strong data-reader-unique-id="88"
        >Le transfert des données personnelles à nos prestataires de services
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="89">
    WEEDEV s’efforce de conserver les Données à caractère personnel en
    France, ou du moins au sein de l’Espace Économique Européen (EEE).
  </p>
  <p data-reader-unique-id="90">
    Vos données personnelles sont hébergées dans des serveurs situés au sein de
    l’Espace Économique Européen (France) par la société Amazon Web Services
    Emea SARL, dont le siège est situé 38 avenue John F. Kennedy, L 1855,
    Luxembourg (Luxembourg). Pour toute question relative au traitement de vos
    données personnelles, vous pouvez consulter l’<a
      href="https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice_2024-07-01_FR-FR.pdf"
      target="_blank"
      data-reader-unique-id="91"
      >Avis Concernant la Protection des Données AWS
    </a>
    (Dernière mise à jour : 1 er juillet 2024).
  </p>

  <p data-reader-unique-id="93">
    WEEDEV est susceptible de transférer les données personnelles des
    Utilisateurs à certains de ses prestataires de services, pour l’exécution de
    leurs prestations. Le cas échéant, seules vos données personnelles
    nécessaires aux destinataires concernés pour exécuter leurs prestations
    leurs sont transférées. Le transfert de ces données personnelles est
    toujours encadré par les clauses des contrats conclus avec ces derniers,
    adaptées en fonction de leur qualité.
  </p>

  <p data-reader-unique-id="95">
    Toutefois, il est possible que les Données que nous recueillons lorsque vous
    utilisez notre plateforme ou dans le cadre de nos services soient
    transférées dans d’autres pays. C’est par exemple le cas si certains de nos
    prestataires sont situés en dehors de l’Espace Economique Européen.
  </p>
  <p data-reader-unique-id="96">
    En cas de Transfert de ce type, nous garantissons que celui-ci soit effectué
    : <br data-reader-unique-id="97" />- Vers un pays assurant un niveau de
    protection adéquat, c’est-à-dire un niveau de protection équivalent à ce que
    les Réglementations européennes exigent ; <br data-reader-unique-id="98" />-
    Dans le cadre de clauses contractuelles types ;
    <br data-reader-unique-id="99" />- Dans le cadre de règles internes
    d’entreprise. <strong data-reader-unique-id="100">‍</strong>
  </p>
  <h2 data-reader-unique-id="101">
    <strong data-reader-unique-id="102">6. TRAITEMENTS DE VOS DONNÉES </strong>
  </h2>
  <p data-reader-unique-id="103">
    Nous collectons vos Données à caractère personnel pour des finalités
    déterminées et sur différents fondements juridiques
  </p>
  <p data-reader-unique-id="104">
    Dans le cadre de l’exécution du contrat ou des mesures précontractuelles,
    vos Données sont traitées pour les finalités suivantes :
  </p>
  <p data-reader-unique-id="105">
    <strong data-reader-unique-id="106">TRAITEMENTS</strong>
    <br data-reader-unique-id="107" />La collecte et le transfert des données
    personnelles des Utilisateurs devant obligatoirement être renseignées lors
    de la demande de mise en contact
    <strong data-reader-unique-id="108"
      ><br data-reader-unique-id="109" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="110" />Permettre la mise en contact des
    Utilisateurs avec un/des Partenaire(s) susceptible(s) de répondre à leur(s)
    besoin(s).
    <strong data-reader-unique-id="111"
      ><br data-reader-unique-id="112" />BASES LÉGALE(S)
    </strong>
    <br data-reader-unique-id="113" />L’exécution du contrat conclu entre les
    Utilisateurs et WEEDEV (art. 6, alinéa 1, b) du RGPD).
    <strong data-reader-unique-id="114"
      ><br data-reader-unique-id="115" />DUREE DE CONSERVATION
      <br data-reader-unique-id="116" />‍</strong
    >14 Mois
  </p>
  <p data-reader-unique-id="117">
    <strong data-reader-unique-id="118">TRAITEMENTS</strong>
    <br data-reader-unique-id="119" />La collecte et le transfert des données
    personnelles des Utilisateurs pouvant facultativement être renseignées lors
    de la demande de mise en contact
    <strong data-reader-unique-id="120"
      ><br data-reader-unique-id="121" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="122" />Permettre à WEEDEV et/ou à nos
    Partenaires de mieux connaître les Utilisateurs.
    <strong data-reader-unique-id="123"
      ><br data-reader-unique-id="124" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="125" />Le consentement des Utilisateurs (art. 6,
    alinéa 1, a) du RGPD).
    <strong data-reader-unique-id="126"
      ><br data-reader-unique-id="127" />DUREE DE CONSERVATION
      <br data-reader-unique-id="128" />‍</strong
    >14 Mois
  </p>
  <p data-reader-unique-id="129">
    ‍<strong data-reader-unique-id="130">TRAITEMENTS</strong>
    <br data-reader-unique-id="131" />Le recueil de votre consentement à
    recevoir des sollicitations publicitaires d’un Partenaire
    <strong data-reader-unique-id="132"
      ><br data-reader-unique-id="133" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="134" />Autoriser un Partenaire à vous adresser
    des sollicitations publicitaires.
    <strong data-reader-unique-id="135"
      ><br data-reader-unique-id="136" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="137" />Le consentement des Utilisateurs (art. 6,
    alinéa 1, a) du RGPD).
    <strong data-reader-unique-id="138"
      ><br data-reader-unique-id="139" />DUREE DE CONSERVATION</strong
    >
    <br data-reader-unique-id="140" />14 Mois
    <strong data-reader-unique-id="141"
      ><br data-reader-unique-id="142" />‍</strong
    >
  </p>
  <p data-reader-unique-id="143">
    <strong data-reader-unique-id="144">TRAITEMENTS</strong>
    <br data-reader-unique-id="145" />L’obtention des informations sur les
    suites données par les Utilisateurs aux offres proposées par les Partenaires
    <strong data-reader-unique-id="146"
      ><br data-reader-unique-id="147" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="148" />Exécuter le contrat qui lie WEEDEV
    à/aux Partenaire(s) auquel/auxquels les données personnelles des
    Utilisateurs ont été transmises.
    <strong data-reader-unique-id="149"
      ><br data-reader-unique-id="150" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="151" />L’intérêt légitime d’WEEDEV (art. 6,
    alinéa 1, f) du RGPD), la légitimité résidant dans la nécessité de vérifier
    que les coordonnées indiquées par les Utilisateurs sont exactes.
    <strong data-reader-unique-id="152"
      ><br data-reader-unique-id="153" />DUREE DE CONSERVATION</strong
    >
    <br data-reader-unique-id="154" />14 Mois
  </p>
  <p data-reader-unique-id="155">
    <strong data-reader-unique-id="156">TRAITEMENTS</strong>
    <br data-reader-unique-id="157" />La collecte de l’adresse IP des
    Utilisateurs
    <strong data-reader-unique-id="158"
      ><br data-reader-unique-id="159" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="160" />Évaluer et renforcer la sécurité du Site
    et/ou des Interfaces ; Réaliser des statistiques relatives aux visites du
    Site et des Interfaces.
    <strong data-reader-unique-id="161"
      ><br data-reader-unique-id="162" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="163" />L’intérêt légitime d’WEEDEV (art. 6,
    alinéa 1, f) du RGPD), la légitimité résidant dans la nécessité de vérifier
    que les coordonnées indiquées par les Utilisateurs sont exactes.
    <strong data-reader-unique-id="164"
      ><br data-reader-unique-id="165" />DUREE DE CONSERVATION</strong
    >
    <br data-reader-unique-id="166" />14 Mois
  </p>
  <p data-reader-unique-id="167">
    <strong data-reader-unique-id="168">TRAITEMENTS</strong>
    <br data-reader-unique-id="169" />Le transfert aux Partenaires de l’adresse
    IP des Utilisateurs
    <strong data-reader-unique-id="170"
      ><br data-reader-unique-id="171" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="172" />Permettre aux Partenaires de s’assurer de
    la bonne exécution par WEEDEV de la demande de mise en contact
    <strong data-reader-unique-id="173"
      ><br data-reader-unique-id="174" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="175" />L’intérêt légitime d’WEEDEV (art. 6,
    alinéa 1, f) du RGPD), la légitimité résidant dans la nécessité de vérifier
    que les coordonnées indiquées par les Utilisateurs sont exactes.
    <br data-reader-unique-id="176" />‍<strong data-reader-unique-id="177"
      >DUREE DE CONSERVATION</strong
    >
    <br data-reader-unique-id="178" />14 Mois
  </p>
  <p data-reader-unique-id="179">
    <strong data-reader-unique-id="180">TRAITEMENTS</strong>
    <br data-reader-unique-id="181" />Le transfert des données personnelles des
    Utilisateurs à des prestataires de services
    <strong data-reader-unique-id="182"
      ><br data-reader-unique-id="183" />FINALITÉ(S)</strong
    >
    <br data-reader-unique-id="184" />Utiliser les outils et services
    nécessaires à l’exploitation d’WEEDEV.
    <strong data-reader-unique-id="185"
      ><br data-reader-unique-id="186" />BASES LÉGALE(S)</strong
    >
    <br data-reader-unique-id="187" />L’intérêt légitime d’WEEDEV (art. 6,
    alinéa 1, f) du RGPD), la légitimité résidant dans la nécessité de vérifier
    que les coordonnées indiquées par les Utilisateurs sont exactes.
    <strong data-reader-unique-id="188"
      ><br data-reader-unique-id="189" />DUREE DE CONSERVATION</strong
    >
    <br data-reader-unique-id="190" />14 Mois
  </p>

  <ol start="1" role="list" data-reader-unique-id="192">
    <li data-reader-unique-id="193">
      <strong data-reader-unique-id="194">Les durées de conservation </strong>
    </li>
  </ol>
  <p data-reader-unique-id="195">
    WEEDEV conserve les données personnelles des Utilisateurs aussi
    longtemps que cela est nécessaire pour les finalités des traitements
    poursuivis.
  </p>
  <ol start="1" role="list" data-reader-unique-id="196">
    <li data-reader-unique-id="197">
      <strong data-reader-unique-id="198">Exceptions </strong>
    </li>
  </ol>
  <p data-reader-unique-id="199">
    Si vous exercez une demande de modification et/ou de suppression de vos
    données personnelles, celles-ci sont modifiées et/ou supprimées dans le mois
    qui suit la réception de cette demande, selon les modalités exposées à
    l’article 8 « Les droits des Utilisateurs » ; En cas de réclamation ou de
    litige, WEEDEV dispose d’un intérêt légitime à conserver vos données
    personnelles jusqu’à leur terme, aux seules fins de pouvoir se défendre.
  </p>
  <p data-reader-unique-id="200">
    Dès lors que vous retirez votre consentement, vos données personnelles sont
    supprimées dans le mois qui suit la réception de cette demande
  </p>
  <ol start="2" role="list" data-reader-unique-id="201">
    <li data-reader-unique-id="202">
      <strong data-reader-unique-id="203"
        >Les mesures de sécurité des données personnelles
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="204">
    WEEDEV met en place les précautions nécessaires à la préservation de
    l’intégrité, la confidentialité et de la sécurité des données personnelles
    des Utilisateurs collectées et traitées afin d’empêcher leur altération,
    leur perte, leur destruction ou encore un accès non autorisé par des tiers,
    de manière accidentelle ou illicite.
  </p>
  <p data-reader-unique-id="205">
    WEEDEV a mis en place des mesures de sécurité technique et
    organisationnelle conformes aux règles de l’art actuelles. En particulier,
    sachez que :
  </p>
  <ul role="list" data-reader-unique-id="206">
    <li data-reader-unique-id="207">
      vos données personnelles ne sont accessibles en clair qu’à nos
      collaborateurs ayant un besoin effectif d’y accéder pour réaliser leurs
      missions, selon un protocole d’accès strictement encadré ;
    </li>
  </ul>
  <ul role="list" data-reader-unique-id="208">
    <li data-reader-unique-id="209">
      vos données personnelles sont, pour les divers traitements réalisés,
      rendues autant que possible anonymes ;
    </li>
    <li data-reader-unique-id="210">
      nos réseaux et serveurs sont sécurisés pour limiter autant que possible
      tout accès par des tiers ;
    </li>
    <li data-reader-unique-id="211">
      la sécurité de nos systèmes d’information est assurée par nos propres
      collaborateurs.
    </li>
  </ul>
  <p data-reader-unique-id="212">
    Néanmoins, sachez que WEEDEV ne peut pas maîtriser tous les risques
    liés au fonctionnement d’internet. WEEDEV attire votre attention sur
    l’existence des risques inhérents à l’utilisation et au fonctionnement
    d’internet, et vous recommande de prendre des mesures pour protéger votre
    vie privée.
  </p>
  <p data-reader-unique-id="213">‍</p>
  <h2 data-reader-unique-id="214">
    <strong data-reader-unique-id="215">7. LES DROITS DES UTILISATEURS </strong>
  </h2>
  <ol start="1" role="list" data-reader-unique-id="216">
    <li data-reader-unique-id="217">
      <strong data-reader-unique-id="218">Énumération des droits </strong>
    </li>
  </ol>
  <p data-reader-unique-id="219">
    ‍<strong data-reader-unique-id="220">‍</strong>
  </p>
  <p data-reader-unique-id="221">
    <strong data-reader-unique-id="222">TYPOLOGIE</strong>
    <br data-reader-unique-id="223" />Droit d’opposition au traitement de vos
    données (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article21"
      target="_blank"
      data-reader-unique-id="224"
      >article 21 RGPD</a
    >) <strong data-reader-unique-id="225">‍</strong>
  </p>
  <p data-reader-unique-id="226">
    <strong data-reader-unique-id="227">OBJET</strong>
    <br data-reader-unique-id="228" />Conformément aux modalités de l’article
    21, alinéa 1 du RGPD, vous avez le droit, à tout moment, de vous opposer aux
    traitements de vos données personnelles, lorsque ces traitements sont
    réalisés sur la base légale de l’intérêt légitime. Lorsque vous vous opposez
    aux traitements par nos soins de vos données personnelles : pour des
    finalités publicitaires, vous pouvez vous y opposer sans nous indiquer de
    motif(s) justifiant votre demande ; pour toutes autres finalités, vous devez
    alors nous indiquer le ou les motif(s) impérieux motivant votre demande
    d’exercice de droit d’opposition. Votre opposition au(x) traitement(s) de
    vos données personnelles vaut pour l’avenir.
  </p>
  <p data-reader-unique-id="229">‍</p>
  <p data-reader-unique-id="230">
    <strong data-reader-unique-id="231">TYPOLOGIE</strong>
    <br data-reader-unique-id="232" />Droit de retirer à tout moment votre
    consentement (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article13"
      target="_blank"
      data-reader-unique-id="233"
      >article 13-2c RGPD</a
    >)
  </p>
  <p data-reader-unique-id="234">
    <strong data-reader-unique-id="235">OBJET</strong>
    <br data-reader-unique-id="236" />Conformément aux modalités de l’article 7,
    alinéa 3 du RGPD, vous avez le droit à tout moment de retirer votre
    consentement aux traitements de vos données personnelles, lorsque ces
    traitements sont réalisés sur la base légale de ce consentement. Vous pouvez
    retirer votre consentement sans nous indiquer de motif(s) justifiant votre
    demande. Le retrait de votre consentement au(x) traitement(s) de vos données
    personnelles vaut pour l’avenir.
  </p>
  <p data-reader-unique-id="237">‍</p>
  <p data-reader-unique-id="238">
    <strong data-reader-unique-id="239">TYPOLOGIE</strong>
    <br data-reader-unique-id="240" />Droit d’accès (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article15"
      target="_blank"
      data-reader-unique-id="241"
      >article 15 RGPD</a
    >) de vos données
  </p>
  <p data-reader-unique-id="242">
    <strong data-reader-unique-id="243">OBJET</strong>
    <br data-reader-unique-id="244" />Conformément à l’article 15 du RGPD, vous
    avez le droit de : nous interroger sur la nature et les modalités des
    traitements de vos données personnelles que nous effectuons ; d’obtenir une
    copie de vos données personnelles.
  </p>
  <p data-reader-unique-id="245">‍</p>
  <p data-reader-unique-id="246">
    <strong data-reader-unique-id="247">TYPOLOGIE</strong>
    <br data-reader-unique-id="248" />Droit de rectification (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article16"
      target="_blank"
      data-reader-unique-id="249"
      >article 16 RGPD</a
    >), de mise à jour, de complétude de vos données
  </p>
  <p data-reader-unique-id="250">
    <strong data-reader-unique-id="251">OBJET</strong>
    <br data-reader-unique-id="252" />Conformément à l’article 16 du RGPD, vous
    avez le droit de nous demander de corriger vos données personnelles qui sont
    erronées ou de les compléter.
  </p>
  <p data-reader-unique-id="253">‍</p>
  <p data-reader-unique-id="254">
    <strong data-reader-unique-id="255">TYPOLOGIE</strong>
    <br data-reader-unique-id="256" />Droit de verrouillage ou d’effacement de
    vos données à caractère personnel (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17"
      target="_blank"
      data-reader-unique-id="257"
      >article 17 RGPD</a
    >)
  </p>
  <p data-reader-unique-id="258">
    <strong data-reader-unique-id="259">OBJET</strong>
    <br data-reader-unique-id="260" />Conformément à l’article 17 du RGPD, vous
    avez le droit de nous demander d’effacer vos données personnelles. Dans ce
    contexte, nous supprimons autant que possible les données personnelles
    concernées. Néanmoins, sachez qu’une telle demande ne peut pas affecter
    notre droit de conserver vos données personnelles nécessaires à satisfaire
    nos obligations légales.
  </p>
  <p data-reader-unique-id="261">‍</p>
  <p data-reader-unique-id="262">
    <strong data-reader-unique-id="263">TYPOLOGIE</strong>
    <br data-reader-unique-id="264" />Droit à la limitation du traitement de vos
    données (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article18"
      target="_blank"
      data-reader-unique-id="265"
      >article 18 RGPD</a
    >)
  </p>
  <p data-reader-unique-id="266">
    <strong data-reader-unique-id="267">OBJET</strong>
    <br data-reader-unique-id="268" />Conformément à l’article 18 du RGPD, vous
    avez le droit de nous demander de limiter le traitement de vos données
    personnelles, dans l’un des cas suivants : lorsque vous contestez
    l’exactitude de ces données personnelles ou que vous considérez que nous les
    traiterions en contrariété avec nos obligations, mais que vous ne souhaitez
    pas, dans l’immédiat, leur suppression ; dans l’un ou l’autre cas, nous
    devons suspendre le traitement de vos données personnelles, le temps de
    procéder aux vérifications nécessaires ; lorsque nous n’avons plus besoin de
    ces données mais que vous en avez besoin pour revendiquer, exercer ou/et
    défendre vos droits ; dans ce cas, nous devons conserver vos données
    personnelles qui vous sont nécessaires.
  </p>
  <p data-reader-unique-id="269">‍</p>
  <p data-reader-unique-id="270">
    <strong data-reader-unique-id="271">TYPOLOGIE</strong>
    <br data-reader-unique-id="272" />Droit à la portabilité des données que
    vous nous avez fournies, lorsque vos données font l’objet de traitements
    automatisés fondés sur votre consentement ou sur un contrat (<a
      href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article20"
      target="_blank"
      data-reader-unique-id="273"
      >article 20 RGPD</a
    >)
  </p>
  <p data-reader-unique-id="274">
    <strong data-reader-unique-id="275">OBJET</strong>
    <br data-reader-unique-id="276" />Conformément à l’article 20 du RGPD, vous
    avez le droit de nous demander de vous transmettre et/ou de transmettre au
    tiers de votre choix vos données personnelles, dans un format techniquement
    exploitable par vous-même ou par ledit tiers
  </p>
  <p data-reader-unique-id="277">‍</p>
  <p data-reader-unique-id="278">
    <strong data-reader-unique-id="279">TYPOLOGIE</strong>
    <br data-reader-unique-id="280" />Droit de définir le sort de vos données
  </p>
  <p data-reader-unique-id="281">
    <strong data-reader-unique-id="282">OBJET</strong>
    <br data-reader-unique-id="283" />Conformément à l’article 85 I. de la CNIL
    vous avez le droit de nous donner des directives relatives au sort de vos
    données personnelles après votre décès.
  </p>
  <p data-reader-unique-id="284">
    <strong data-reader-unique-id="285">TYPOLOGIE</strong>
    <br data-reader-unique-id="286" />Droit de saisir une autorité de contrôle
  </p>
  <p data-reader-unique-id="287">
    Vous avez le droit d’introduire une réclamation auprès des autorités de
    contrôle et notamment de la CNIL (<a
      href="https://www.cnil.fr/fr/plaintes"
      target="_blank"
      data-reader-unique-id="288"
      >https://www.cnil.fr/fr/plaintes</a
    >).
  </p>
  <ol start="2" role="list" data-reader-unique-id="289">
    <li data-reader-unique-id="290">
      <strong data-reader-unique-id="291">Modalités d’exercice </strong>
    </li>
  </ol>
  <p data-reader-unique-id="292">
    Vous pouvez exercer vos droits en adressant un courrier électronique à
    l’adresse <a
      href="mailto:dpo@hipto.com"
      target="_blank"
      data-reader-unique-id="293"
      >dpo@hipto.com</a
    > ou par courrier à DPO WEEDEV, Cabinet Haas Avocats, 32 rue la
    Boétie, 75008 Paris ou en ligne via notre
    <a
      href="https://zfrmz.eu/AzrmdQxcMsEpSe8ZSMF7"
      target="_blank"
      data-reader-unique-id="294"
      >formulaire</a
    >
  </p>
  <p data-reader-unique-id="295">
    Sachez qu’WEEDEV est susceptible de vous demander des informations
    complémentaires pour confirmer votre identité.
  </p>
  <ol start="3" role="list" data-reader-unique-id="296">
    <li data-reader-unique-id="297">
      <strong data-reader-unique-id="298">Traitement de votre demande </strong>
    </li>
  </ol>
  <p data-reader-unique-id="299">
    Une fois votre demande d’exercice de droit(s) réceptionnée, le cas échéant,
    WEEDEV informe le ou les Partenaire(s) auquel/auxquels vos données
    personnelles ont été transmises, pour qu’il(s) traite(nt) votre demande. En
    effet, une fois vos données personnelles obtenues pour les besoins d’être
    mis en relation avec nos Partenaires transférées à ces derniers, WEEDEV
    ne vous contacte pas directement. En particulier, WEEDEV ne vous
    adresse jamais des emails de prospection. Ainsi, il est possible qu’un
    certain délai intervienne entre le moment où WEEDEV confirme avoir
    traité votre demande, et celui où cette dernière est également traitée par
    le ou les Partenaire(s) concernés.
  </p>
  <p data-reader-unique-id="300">
    WEEDEV conserve vos données personnelles transmises à l’occasion de
    votre d’exercice de droits ainsi que nos correspondances subséquentes. La
    base légale pour le traitement de ces données personnelles est l’article 6,
    alinéa 1 f) du RGPD, à savoir notre intérêt légitime. La légitimité de ces
    traitements est de pouvoir prouver que nous avons traité votre demande
    d’exercice de droit(s), dans les délais impartis. Ces données personnelles
    sont conservées sous forme d’archives, pour une durée de 5 ans à compter du
    traitement définitif de votre demande, à l’exception de la copie de votre
    carte d’identité qui sera supprimée dès votre identité confirmée. Seuls un
    référent et le DPO ont accès à cette base d’archives.
  </p>
  <ol start="4" role="list" data-reader-unique-id="301">
    <li data-reader-unique-id="302">
      <strong data-reader-unique-id="303"
        >Sollicitations publicitaires adressées par nos Partenaires
      </strong>
    </li>
  </ol>
  <p data-reader-unique-id="304">
    Dans l’hypothèse où vous souhaiteriez procéder au retrait de votre
    consentement à la réception de sollicitations publicitaires adressées par un
    de nos Partenaires, WEEDEV vous invite à exercer votre demande
    directement auprès de ce dernier. En effet, en aucun cas WEEDEV ne vous
    adresse des sollicitations publicitaires.
  </p>

  <p data-reader-unique-id="306">Dernière mise à jour: Septembre 2024</p>
  <p data-reader-unique-id="307">‍</p>
</div>`;
